import { useApplicationName } from 'hooks/use-application-name'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon, Label } from 'semantic-ui-react'

interface IDisclaimerProps {}

type Props = IDisclaimerProps

export const Disclaimer: React.FC<Props> = () => {
  const { t } = useTranslation()
  const { appName } = useApplicationName()

  return (
    <Label>
      <Icon name='exclamation' />
      <i data-testid='disclaimer'>{t('vehiclevalidation.modal_disclaimerWithAppName', { appName })}</i>
    </Label>
  )
}

Disclaimer.displayName = 'Disclaimer'
export default Disclaimer
